const rowColors = {
  rowColor1: '#fbe9e7',
  rowColor2: '#e8f5e9',
  rowColor3: '#b0d6a0',
};

export default rowColors;
